import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import { Collection } from '../collection'
import { CollectionAll } from '../collection-all'
import type { Feature } from '../feature'
import { Name } from '../name'

/**
 * Bootstraps one dynamic Organization EC when it is missing
 */
export const onBootstrap = store.effects.create(
  (
    organizationsFeature: Feature,
    ecDependencies: ec.InjectableDependencies,
    scenarioContext$: Collection.Config['scenarioContext$'],
    canEditJointUseSg: Collection.Config['canEditJointUseSg'],
  ) =>
    organizationsFeature.actions.bootstrap.observe().pipe(
      rxjsUtils.latestFrom(({ data: { entityId } }) => ({
        entityId: rxjs.of(entityId),
        existingAllEc: ec.Collection.instances.tryGet(Name.All.from(entityId))
          .asObservable,
        existingEc: ec.Collection.instances.tryGet(Name.from(entityId))
          .asObservable,
      })),
      rxjs.map(({ entityId, existingEc, existingAllEc }) => {
        if (!existingEc) {
          new Collection(
            {
              canEditJointUseSg,
              entityId,
              organizationsFeature,
              scenarioContext$,
            },
            ecDependencies,
          )
        }
        if (!existingAllEc) {
          new CollectionAll(
            {
              entityId,
              organizationsFeature,
              scenarioContext$,
            },
            ecDependencies,
          )
        }
        return store.effects.SKIP
      }),
    ),
)
